import { forEachObjIndexed, isNil } from 'ramda'
import { CampaignAudience, EmbedConfiguration } from 'types/embed'

import { DriftConfigOptions } from './types'

const WIDGET_THEME_MESSAGES = Object.freeze({
  welcomeMessage: 'welcomeMessage',
  awayMessage: 'awayMessage',
  emailCaptureMessage: 'emailCaptureMessage',
  thankYouMessage: 'confirmationMessage',
})

export const apiWarning = (...args: any[]) => console.warn('Drift API -', ...args)
export const apiError = (...args: any[]) => console.error('Drift API -', ...args)

export const configOptionsToEmbedConfiguration = (options: DriftConfigOptions): Partial<EmbedConfiguration> => {
  const configuration: Partial<EmbedConfiguration> = {
    theme: {},
  }

  if (isNil(options)) {
    return configuration
  }

  // Commented out properties were part of sdk-js (v1) and are not supported by widget (v2)
  const {
    locale,
    enableWelcomeMessage,
    enableCampaigns,
    enableChatTargeting,
    // enableSoundNotifications,
    backgroundColor,
    foregroundColor,
    activeColor,
    textColor,
    widgetBackgroundColor,
    autoAssigneeId,
    autoAssignee,
    inboxId,
    // widgetStatus,
    // widgetMode,
    // welcomeMessageDelay,
    enabled,
    profileMode,
    messages,
    cookieDomain,
    verticalOffset
  } = options

  if (locale) {
    configuration.locale = locale
  }

  if (!isNil(enableWelcomeMessage)) {
    configuration.theme.showWelcomeMessage = !!enableWelcomeMessage
  }

  if (!isNil(enableCampaigns)) {
    configuration.campaignsEnabled = enableCampaigns
  }

  if (enableChatTargeting === false) {
    configuration.theme.audience = CampaignAudience.EVERYONE
    configuration.theme.conditions = []
  }

  // if (!isNil(enableSoundNotifications)) {
  //   configuration.theme.soundNotificationEnabled = enableSoundNotifications
  // }

  if (backgroundColor) {
    configuration.theme.backgroundColor = backgroundColor.replace('#', '')
  }

  if (foregroundColor) {
    configuration.theme.foregroundColor = foregroundColor.replace('#', '')
  }

  if (activeColor) {
    configuration.theme.activeColor = activeColor.replace('#', '')
  }

  if (textColor) {
    configuration.theme.textColor = textColor.replace('#', '')
  }

  if (widgetBackgroundColor) {
    configuration.theme.widgetBackgroundColor = widgetBackgroundColor.replace('#', '')
  }

  if (!isNil(autoAssigneeId)) {
    configuration.autoAssigneeId = autoAssigneeId
  }

  if (!isNil(autoAssignee)) {
    configuration.autoAssignee = autoAssignee
  }

  if (inboxId) {
    configuration.inboxId = inboxId
  }

  if (!isNil(verticalOffset)) {
    configuration.verticalOffset = verticalOffset
  }

  // if (widgetStatus) {
  //   configuration.widgetStatus = widgetStatus
  // }

  // if (widgetMode) {
  //   configuration.widgetMode = widgetMode
  // }

  // if (!isNil(welcomeMessageDelay)) {
  //   configuration.theme.welcomeMessageDelay = welcomeMessageDelay
  // }

  if (!isNil(enabled)) {
    configuration.enabled = !!enabled
  }

  if (!isNil(profileMode)) {
    configuration.profileMode = !!profileMode
  }

  if (!isNil(messages)) {
    forEachObjIndexed((internalName, externalName) => {
      if (messages[externalName]) {
        configuration.theme[internalName] = messages[externalName]
      }
    }, WIDGET_THEME_MESSAGES)
  }

  if (!isNil(cookieDomain)) {
    configuration.theme.cookieDomains = [cookieDomain]
  }

  return configuration
}
